import "./ScrollablePills.css";

import { PillData } from "../../../models";
import { TextLink } from "../../navigation";
import { Pill } from "..";

interface ScrollablePillsProps {
  pills: PillData[];
  linkText: string;
  linkOnClick: () => void;
  readonly?: boolean;
}

export const ScrollablePills = ({ pills, linkText, linkOnClick, readonly }: ScrollablePillsProps): JSX.Element => {
  return (
    <div className="ScrollablePillsContainer">
      {readonly ? (
        <p className="body1">
          <b>{linkText}</b>
        </p>
      ) : (
        <TextLink onAction={linkOnClick}>
          <p className="body1">
            <b>{linkText}</b>
          </p>
        </TextLink>
      )}
      <div className="ScrollablePills">
        {pills.map((pill) => (
          <Pill key={pill.key} label={pill.label} variant="grey-alternate" fontWeight={300} />
        ))}
      </div>
    </div>
  );
};
